<script>
import VSelect from '@alfsnd/vue-bootstrap-select';
import { BTable, BFormDatepicker, BInputGroup, BFormInput, BInputGroupAppend, BFormSelect, BModal } from 'bootstrap-vue'
import DibbleTranslation from "../../translation/translation";
import Helper from '../../appHelper';
import DibbleAPI from "../../api";
import DibbleJS from "../../dibble";

export default {
    name: "Users",
    components: {
        VSelect, BTable, BFormDatepicker, BFormSelect,
        BInputGroup, BFormInput, BInputGroupAppend, BModal
    },
    data() {
        return {            
            translate: DibbleTranslation,
            showInfoModal: false,
            formUser:[],
            countries: [
                {
                    value: null,
                    text: "-- None --"
                }
            ],
            totalUser: 0,
            user_status: [],
            filter_from_date: "",
            filter_to_date: "",
            filter_to_date_formatted: '',
            filter_to_date_selected: '',            
            search: {
                keyword: '',
                status: {},
                country: {
                    value: null,
                    text: "-- None --"
                },
            },
            fields: [
                { key: 'full_name', label: DibbleTranslation.trans('pinker.fullName'), sortable: true },                
                { key: 'profile_img', label: DibbleTranslation.trans('pinker.profileImage'), sortable: true },
                { key: 'phone_number', label: DibbleTranslation.trans('pinker.phoneNumber'), sortable: true },
                { key: 'gender', label: DibbleTranslation.trans('pinker.gender'), sortable: true },
                { key: 'have_business_account', label: DibbleTranslation.trans('pinker.businessProfile'), sortable: true },
                { key: 'created_date', label: DibbleTranslation.trans('pinker.registrationDate'), sortable: true,
                  formatter: (value) => {
                    return value ? this.$moment(value).format('DD-MM-YYYY') : ''
                  },
                },
                { key: 'is_active', label: DibbleTranslation.trans('pinker.isActive'), sortable: false},
                { key: 'feedback_list', label: DibbleTranslation.trans('pinker.feedbackList'), sortable: true },                
            ],
            selectedStatus: null,
            statusOptions: [
                { value: null, text: DibbleTranslation.trans("pinker.selectUserStatus") },
                { value: true, text: DibbleTranslation.trans("pinker.active") },
                { value: false, text: DibbleTranslation.trans("pinker.inActive") }
            ],
            selectedBusinessCat: null,
            businessCatOptions: [
                { value: null, text: DibbleTranslation.trans("pinker.selectBusinessCategory") },
                { value: 1, text: DibbleTranslation.trans("pinker.selfEmployed") },
                { value: 2, text: DibbleTranslation.trans("pinker.employee") },
                { value: 3, text: DibbleTranslation.trans("pinker.organization") },
                { value: 4, text: DibbleTranslation.trans("pinker.company") },
            ],
            selectedUserType: null,
            UserTypeOptions: [
                { value: null, text: DibbleTranslation.trans("pinker.selectUserType") },
                { value: 3, text: DibbleTranslation.trans("pinker.private") },
                { value: 4, text: DibbleTranslation.trans("pinker.business") },
                { value: 5, text: DibbleTranslation.trans("pinker.privateABusiness") },
            ],
            users: [],
            sourceUsers: [],
            pagination: {
                currentPage: 1,
                totalPage: 0
            },
            feedbackListForm: {
                isOpen: false,
                title: DibbleTranslation.trans("pinker.feedbackList"),
                items: []
            },
            modalBusinessProfile: {
                isOpen: false,
                title: DibbleTranslation.trans("pinker.businessProfile"),
                user: null
            },
            statisticForm: {
                isOpenStatisticModal: false,
                isAllApp: true,
                title: "",
                total_memo: 0,
                total_safe_memo: 0,
                total_space_memo: 0,
                total_ghost_memo: 0,
                total_complete_questionair: 0,
                total_share_memo: 0,
                total_report_to_user: 0,
                total_repost_from_user: 0,
                total_turnover_all: 0,
                total_turnover_each_subscription: 0,
            }
        }
    },
    mounted() {
        const scrollContent = document.getElementById('scroll-main-content')
        scrollContent.style.height = window.innerHeight*0.8 +  "px"
    },
    created() {
        this.loadUsers();
    },
    methods: {
        trans(key) {
            return this.translate.trans(key)
        },
        moment(value) {
            return this.$moment(value)
        },
        momentWithFormat(value, dateFormat) {
            return this.$moment(value, dateFormat)
        },
        formatDate(dateString) {
            return this.$moment(dateString).format('DD-MM-YYYY h:mm:ss');
        },
        isPrivateUserOnly(userItem) {
            return userItem.user_type === Helper.userType.private;
        },
        hasBussinessProfile(userItem) {
            return userItem.have_business_account > 0
        },
        onFilterchange (filterName, event) {            
            if (filterName === "dateRangeFrom") {
                this.filter_from_date = event.target.value;
                this.filterUsers("date");
            } else if (filterName === "dateRangeTo") {
                this.filter_to_date = event.target.value;
                this.filterUsers("date");
            } else if (filterName === "status") {                
                this.filterUsers("status");
            } else if (filterName === "userType") {
                this.filterUsers("userType");
            }
        },
        filterUsers (filterType) {            
            if (filterType === "date") {
                const tempUserList = []                
                if (this.filter_from_date !== "" && this.filter_to_date !== "") {                    
                    const momentFrom = this.momentWithFormat(this.filter_from_date, DibbleAPI.apiDateFormat);
                    const momentTo = this.momentWithFormat(this.filter_to_date, DibbleAPI.apiDateFormat);
                    this.sourceUsers.map((item, index) => {
                        const userCreatedTime = this.momentWithFormat(item.created_date, DibbleAPI.apiDateFormatFull);
                        if (userCreatedTime.isAfter(momentFrom) && userCreatedTime.isBefore(momentTo)) {
                            tempUserList.push(item)
                        }
                        return item;
                    })
                    this.users = tempUserList
                } else {
                    if (this.filter_from_date !== "") {                        
                        const momentFrom = this.momentWithFormat(this.filter_from_date, DibbleAPI.apiDateFormat);
                        this.sourceUsers.map((item, index) => {
                            const userCreatedTime = this.momentWithFormat(item.created_date, DibbleAPI.apiDateFormatFull);                            
                            if (userCreatedTime.isAfter(momentFrom)) {
                                tempUserList.push(item)
                            }
                            return item;
                        })
                        this.users = tempUserList
                    } else if (this.filter_to_date !== "") {                        
                        const momentTo = this.momentWithFormat(this.filter_to_date, DibbleAPI.apiDateFormat);
                        this.sourceUsers.map((item, index) => {
                            const userCreatedTime = this.momentWithFormat(item.created_date, DibbleAPI.apiDateFormatFull);
                            if (userCreatedTime.isBefore(momentTo)) {
                                tempUserList.push(item)
                            }
                            return item;
                        })
                        this.users = tempUserList
                    } else {
                        this.users = this.sourceUsers
                    }
                }                
            } else if (filterType === "status") {
                if (this.selectedStatus === null) {
                    this.users = this.sourceUsers
                } else {
                    const tempUserList = []
                    this.sourceUsers.map((item, index) => {
                        const activeValue = this.selectedStatus ? 1 : 0
                        if (item.is_active === activeValue) {
                            tempUserList.push(item)
                        }
                        return item;
                    })
                    this.users = tempUserList
                }
            } else if (filterType === "userType") {
                if (this.selectedUserType === null) {
                    this.users = this.sourceUsers
                } else {
                    const tempUserList = []
                    this.sourceUsers.map((item, index) => {
                        if (item.user_type === this.selectedUserType) {
                            tempUserList.push(item)
                        }
                        return item;
                    })
                    this.users = tempUserList
                }
            }
        },
        showBusinessProfile(user) {
            const params = {
                '#request': DibbleAPI.api.getUserProfile,
                user_id: user.user_id,
                date_start: "",
                date_end: "",
                feedback_user_type: 4,
                userLang: this.translate.currentLocale
            };
            DibbleJS.showLoader();
            DibbleJS.callAnomyousRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                    this.modalBusinessProfile.isOpen = true
                    this.modalBusinessProfile.user = responseData.user
                } else {
                    DibbleJS.toastErrorMessage(responseData.message);
                }
            })            
        },
        closeBusinessProfile() {
            this.modalBusinessProfile.isOpen = false
        },        
        loadUsers() {
            const params = {
                '#request': DibbleAPI.api.admin.getUsers,
                sort_direction: false,
                // start_date: '2023-01-01',
                // end_date: this.moment().format(DibbleAPI.apiDateFormat)
            };
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, this._onLoadUsersSuccess)
        },
        _onLoadUsersSuccess(responseData) {
            DibbleJS.hideLoader();
            if (DibbleAPI.isResponseSuccess(responseData)) {
                this.users = responseData.users_list;
                this.sourceUsers = responseData.users_list;
            } else {
                DibbleJS.toastErrorMessage(responseData.message);
            }
        },
        searchUser (searhKey) {            
            if (searhKey === "") {
                this.users = this.sourceUsers
            } else {
                const tempUserList = []
                this.sourceUsers.map((item, index) => {
                    if (item.full_name != null) {
                        const fullname = item.full_name == null ? "" : item.full_name;
                        if (fullname.toLowerCase().includes(searhKey.toLowerCase())){
                            tempUserList.push(item)
                        }
                        return item;
                    } else {
                        return null;
                    }
                })
                this.users = tempUserList
            }
        },
        getBackgroundColorCss (color) {
            return "background-color: " + color;
        },
        getDisplayName (feedbackItem) {
            if (feedbackItem.user_sender_displayname=== 1) {
                return feedbackItem.user_name
            } else {
                return this.translate.trans('pinker.anonymous')                
            }
        },
        showFeedbackListModal (dataItem) {
            const params = {
                '#request': DibbleAPI.api.getUserProfile,
                user_id: dataItem.user_id,
                date_start: "",
                date_end: "",
                feedback_user_type: 3,
                userLang: this.translate.currentLocale
            };
            DibbleJS.showLoader();
            DibbleJS.callAnomyousRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                    this.feedbackListForm.isOpen = true
                    if (responseData.feedbacks != null && responseData.feedbacks.length > 0) {
                        this.feedbackListForm.items = responseData.feedbacks
                    }
                } else {
                    DibbleJS.toastErrorMessage(responseData.message);
                }
            })               
        },
        loadUserStatistic (userId, callback) {
            DibbleJS.showLoader()
            const rq = {
                "#request": DibbleAPI.api.getUserStatistic,
                user_id: userId
            }
            DibbleJS.callApiRequest( 
                rq,
                (data) => {
                    DibbleJS.hideLoader()
                    if (DibbleAPI.isResponseSuccess(data)){
                        callback(data)
                    } else {
                        DibbleJS.toastErrorMessage(data.message)
                    }
                }
            )
        },
        loadAppStatistic (callback) {
            DibbleJS.showLoader()
            const rq = {
                "#request": DibbleAPI.api.getAllUserStatistic
            }
            DibbleJS.callApiRequest( 
                rq,
                (data) => {
                    DibbleJS.hideLoader()
                    if (DibbleAPI.isResponseSuccess(data)){
                        callback(data)
                    } else {
                        DibbleJS.toastErrorMessage(data.message)
                    }
                }
            )
        },
        closeFeebacklistModal () {
            this.feedbackListForm.isOpen = false
        },
        checkShowHeritageButton (item) {
            if ((item.timeline_email != null && item.timeline_email !== '') 
                || (item.safe_box_email != null && item.safe_box_email !== '')) {                    
                    return item.heritage_send_status
            } else {
                return ""
            }
        },
        updateHeritage (item) {
            const params = {
                "#request": DibbleAPI.api.sendHeritage,
                user_id: item.user_id
            };            
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, 
            (data) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(data)) {
                    DibbleJS.toastSuccessMessage(data.message);
                    this.loadUsers()
                } else {
                    DibbleJS.toastErrorMessage(data.message);
                }
            })
        },
        cancelHeritage (item) {
            const params = {
                "#request": DibbleAPI.api.cancelSendHeritage,
                user_id: item.user_id
            };            
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, 
            (data) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(data)) {
                    DibbleJS.toastSuccessMessage(data.message);
                    this.loadUsers()
                } else {
                    DibbleJS.toastErrorMessage(data.message);
                }
            })
        },
        toggleUserActive(item) {
            const params = {
              '#request': DibbleAPI.api.blockUser,
              user_id: item.user_id,
              status: item.is_active === 1
            };

            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                  DibbleJS.toastSuccessMessage(responseData.message);
                  this.loadUsers();
                } else {
                  DibbleJS.toastErrorMessage(responseData.message);
                }
            })
        }
    }
}
</script>

<style>
    .user-image {
        width: 40px;
        height: 40px;
    }
    .v-dropdown-container {
        max-height: 250px;
        overflow-y: scroll;
    }
    .small-text-box {
        width: 50px
    }
    .medium-text-box {
        width: 120px
    }    
</style>

<template src="./Templates/Users.html"></template>


